import React, {Component} from 'react'
import NachweisListeAzubi from '#components/o/NachweisListe/NachweisListeAzubi'

export default class AlteAusbildungsnachweiseOverview extends Component {
  render() {
    return <NachweisListeAzubi showArchivedAusbildungsnachweise />
  }
}
